<template>
  <div class="index-container">
    <div class="img-container">
      <img src="../assets/index-bg1.png" alt="">
    </div>
    <div class="text1">教育产品</div>
    <div class="text2">产品分类细致 满足各类教学场景</div>
    <div class="card-row">
      <div class="card card1">
        <div class="card-img-container">
          <img src="../assets/01.png" alt="">
        </div>
        <span class="card-row2">基础教育</span>
        <span class="card-row3">A.I+教育</span>
        <span class="card-row3">帮助更多的学生提高成绩</span>
      </div>
      <div class="card card2">
        <div class="card-img-container">
          <img src="../assets/02.png" alt="">
        </div>
        <span class="card-row2">中等职业教育</span>
        <span class="card-row3">针对学生大数据教研分析</span>
        <span class="card-row3">实现符合个性化成长</span>
      </div>
      <div class="card card3">
        <div class="card-img-container">
          <img src="../assets/03.png" alt="">
        </div>
        <span class="card-row2">高等教育</span>
        <span class="card-row3">教育应用的特色软件平台</span>
        <span class="card-row3">和系统</span>
      </div>
      <div class="card card4">
        <div class="card-img-container">
          <img src="../assets/04.png" alt="">
        </div>
        <span class="card-row2">网络学院</span>
        <span class="card-row3">精品课程网络教学平台的</span>
        <span class="card-row3">构建和应用</span>
      </div>
      <div class="card card5">
        <div class="card-img-container">
          <img src="../assets/05.png" alt="">
        </div>
        <span class="card-row2">基础教育</span>
        <span class="card-row3">专业、深入、精细化的教</span>
        <span class="card-row3">育理论研究</span>
      </div>
    </div>
    <div class="case-row">
      <div class="text1">成功案例</div>
      <div class="text2">实现常态化应用 获得一致好评</div>
      <div class="case-img-row">
        <!-- <div> -->
          <!-- <div class="case-left-img-container"> -->
          <img src="../assets/case-left.png" alt="" class="case-left-img">
        <!-- </div> -->
        <!-- <div class="case-right-img-container"> -->
          <img src="../assets/case-right.png" alt="" class="case-right-img">
        <!-- </div> -->
        <!-- </div> -->
        
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'index-content',
    data () {
      return {
      }
    }
  }
</script>

<style scoped>
.index-container{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.img-container{
  width: 100%;
  /* height: 560px; */
}
.img-container img{
  border-left: 1px solid #2086E5;
  border-right: 1px solid #2086E5;
  width: 100%;
  height: 100%;
}
.text1{
  font-size:34px;
  font-family:MicrosoftYaHei-Bold;
  font-weight:bold;
  color:rgba(17,17,17,1);
  margin-top: 86px;
}
.text2{
  margin-top: 20px;
  font-weight:400;
  color:rgba(68,68,68,1);
  font-size:20px;
}
.card-row{
  margin-top: 68px;
  display: flex;
}
.card-img-container{
  width: 109px;
  height: 109px;
}
.card-img-container img{
  width: 100%;
  height: 100%;
}
.card{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.card-row2{
  margin-top: 27px;
  margin-bottom: 15px;
  color:rgba(17,17,17,1);
  font-size:22px;
}
.card-row3{
  color:rgba(136,136,136,1);
  font-size:18px;
}
.card1{
  margin-right: 41px;
}
.card2{
  margin-right: 47px;
}
.card3{
  margin-right: 44px;
}
.card4{
  margin-right: 46px;
}
.case-row{
  width:100%;
  height:840px;
  background:rgba(250,250,250,1);
  margin-top: 97px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.case-left-img-container{
  width: 26.4%;
  height: 571px;
  position: relative;
  left: 47px;
}
.case-left-img-container img{
  width: 100%;
  height: 100%;
}
.case-right-img-container{
  width: 38.02%;
  height: 555px;
  position: relative;
  right: 48px;
}
.case-right-img-container img{
  width: 100%;
  height: 100%;
}
.case-left-img{
  width: 36.4%;
  position: relative;
  left: 47px;
  z-index: 1;
}
.case-right-img{
  width: 48.02%;
  position: relative;
  right: 48px;
}
.case-img-row{
  display: flex;
  margin-top: 40px;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/index-content.vue